$(document).ready(function(){
  
$('.announcement-slider').slick({
  infinite: true,
  arrows: false,
  dots: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
});

// Mobile Menu Drawer Start
  
$('.categories-container .tab-title-container .title-block').click(function(){
  $(this).siblings().removeClass('active');
  $(this).addClass('active');
  $('.tab-content-container .content-block').removeClass('active');
  $(`[content-tab-id="${ $(this).attr('tab-id') }"]`).addClass('active');
})

$('.categories-container .tab-title-container .title-block:first-child').trigger('click');  
  
// Mobile Menu Drawer End  


// Featured Collection Slider
 $('.featured-collection-slider').slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
        arrows: true,
      }
    },
    {
      breakpoint: 990,
     settings: "unslick"
    }
  ]
});  

  

$('#testimonial-slider').slick({
  infinite: false,
  speed: 300,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    }
  ]
});

$('.location-list-container .store-image-wrapper .image-container-slider').each(function(index, slider) {
  var $slider = $(slider);
  var $progressBar = $slider.closest('.store-image-wrapper').find('.progress');
  var $progressBarLabel = $slider.closest('.store-image-wrapper').find('.slider__label');
  
  // Initialize slick for each slider
  $slider.slick({
    infinite: false,
    arrows: false,
    dots: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
  });

  // Function to update the progress bar
  function updateProgress(slick, currentSlide) {
    var calc = ((currentSlide + 1) / slick.slideCount) * 100;

    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc.toFixed(10));

    $progressBarLabel.text(calc.toFixed(4) + '% completed');
  }

  // On slider initialization, check the number of slides and set the initial progress bar value
  $slider.on('init', function(event, slick) {
    if (slick.slideCount === 1) {
      // Hide the progress bar if there's only one slide
      $progressBar.hide();
    } else {
      // Show the progress bar and update it if there are more than one slide
      $progressBar.show();
      updateProgress(slick, slick.currentSlide);
    }
  });

  // Update progress bar on slide change
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if (slick.slideCount > 1) {
      updateProgress(slick, nextSlide);
    }
  });

  // Trigger the init event after setting up the slider
  $slider.slick('setPosition');

  // Manually trigger the init event
  $slider.trigger('init', [$slider.slick('getSlick')]);
});   
  
$('#new-testimonial-slider').slick({
  speed: 300,
  infinite: true,
  slidesToShow: 1.1,
  slidesToScroll: 1,
  initialSlide: 1,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        initialSlide: 0,
       
      }
    },
     {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 0,
        
      }
    }
  ]
});  
  
// Washcare Guide slider PDP
 $('#cleaning-step').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false,
        arrows: false,
      }
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: true,
      }
    }
  ]
}); 

if(window.innerWidth < 750) {  
  $('.shoe-cleaning-step .section-title').click(function(){
    if($(this).hasClass('active')){
       $(this).removeClass('active');
       $('.shoe-cleaning-step .content-and-slider-container').fadeOut(200);
    }else{
       $('#cleaning-step').slick('refresh');
      $(this).addClass('active');
      $(`[data-tab-content="${ $(this).attr('data-tab-title') }"]`).fadeIn(200); 
    }
  })
}


//Product Description accordian  

  // $('.description-accordion .accordian-title').click(function(){
  //      if($(this).hasClass('active')){
  //      $(this).removeClass('active');
  //      $('.template-product .description-accordion .product__description').hide(300);
  //   }else{
  //     $(this).addClass('active');
  //     $(`[tab-content="${ $(this).attr('tab-title') }"]`).show(300); 
  //        console.log($(this).attr('tab-title'))
  //   }
  // })
   $(".description-accordion .accordian-title").click(function () {

    $(this).next().slideToggle(300);
    $(this).toggleClass("active");
  });
 
  
/*Footer SEO navigation Tab Start*/
$('.seo p').click(function(){
  if($('.seo p').hasClass('active')){
    $('.seo p').removeClass('active')
  }else{
    $(this).addClass('active')
  }
  $(`[tab-container="${ $(this).attr('tab-title')}"]`).toggle(200);
}) 

$('.about-us p').click(function(){
  if($('.about-us p').hasClass('active')){
    $('.about-us p').removeClass('active')
  }else{
    $(this).addClass('active')
  }

  $(`[footer-tab-container="${ $(this).attr('footer-tab-title')}"]`).toggle(200);
}) 
  

  
/*Footer SEO navigation Tab End*/


/* Main Navigation Acc icon dropdown Start*/ 

$('.login-and-toolmenu').click(function(){
    if($(this).hasClass('active')){
      $('.login-and-toolmenu').removeClass('active');
    }else{
       $('.login-and-toolmenu').addClass('active');
    }
})

// When click outside dropdown close
$(document).on("click", function(event) {
  if (!$(event.target).closest(".login-and-toolmenu").length) {
    $('.login-and-toolmenu').removeClass('active');
  }
});
  
/* Main Navigation Acc icon dropdown End*/  

let brandLogoSlider = () => { 
    $('.logo-sliders').slick({
      dots: false,
      infinite: false,
        arrows: false,
      speed: 300,
      slidesToShow: 6,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
}

brandLogoSlider();  
  
document.addEventListener("ajaxloader:render",function(e){
  brandLogoSlider();
});
  
  
})// document Load end





$(document).ready(function() {
  $(".timeline .timeline-block .item .circle-line").click(function() { 

    $(".timeline .timeline-block .item .content").removeClass("open");

    $(".timeline .timeline-block .item .circle-line").removeClass("active");

    $(".timeline .timeline-block .item img").removeClass("zoom"),

    $(this).siblings('.image').children('img').addClass("zoom");
    
    $(this).next().addClass("open");
    $(this).addClass("active");

    $(this).parent().parent(".timeline-block").addClass("img-zoom");

  })


  $(".timeline .timeline-block .item .image").click(function() { 

    $(".timeline .timeline-block .item .content").removeClass("open");

    $(".timeline .timeline-block .item .circle-line").removeClass("active");

    $(".timeline .timeline-block .item img").removeClass("zoom"),

    $(this).children('img').addClass("zoom");
    
    $(this).siblings('.content').addClass("open");
    $(this).siblings('.circle-line').addClass("active");

    $(this).parent().parent(".timeline-block").addClass("img-zoom");

  })
})



// let target = '.banner-with-below-text .content p span, .image-with-text-new .content p span, .gallery-grid-with-content-two .right-content p span, .gallery-grid-with-content-two .left-content p span, .gallery-grid-with-content-two .content p span, .banner-below-image-with-text .image-with-text .content p span';

// const prices = gsap.utils.toArray(target);
// // gsap.set(target, {opacity:0.3, transformOrigin:'left center'})
// prices.forEach(price => {
// gsap.to(price, {
//     opacity:1, duration:0.3,
//     scrollTrigger: {
//       trigger: price,
//       start:'top 60%',
//       end:'top 30%',
//       toggleActions: "play reverse play reverse",
//       markers:false
//     }
//   })
// })


let target = '.banner-with-below-text .content p span, .image-with-text-new .content p span, .gallery-grid-with-content-two .right-content p span, .gallery-grid-with-content-two .left-content p span, .gallery-grid-with-content-two .content p span, .banner-below-image-with-text .image-with-text .content p span';

const prices = gsap.utils.toArray(target);
// gsap.set(target, {opacity:0.3, transformOrigin:'left center'})
prices.forEach(price => {
gsap.to(price, {
    opacity:1, 
    duration:0.5,
    scrollTrigger: {
    trigger: price,
    start:'top 60%',
    end:'top 30%',
    toggleActions: "play reverse play reverse",
    markers:false
    }
  })
})

// Product page Load More Swatches

// Login and Sign up Form tab 
$( document ).ready(function() {
 setTimeout(function () {
    $('.form-block .tabs li:first-child a').trigger('click');
  }, 200);

  $(".form-block .tabs li a" ).click(function(e) {
    e.preventDefault();
    $( '.form-block .tabs li a').removeClass('active');
    $( this ).addClass('active');
    var CurrentTab = $( this ).attr('tab-id');
    var selectTab = '[data-tab-id="'+ CurrentTab +'"]';

    $(".account-control .form-block .form-field-container .customer").hide();
    $(selectTab).fadeIn('fast');
     // $('.article-block .article').slick('refresh');
  });

// Slider in Login and Sign up Page
  $('.account-control .image-block .slider-images').slick({
    infinite: false,
    dots:true,
    slidesToShow: 1,
    slidesToScroll: 1
  });


  let currentPageUrl = window.location.pathname;
  // let splitedUrl = currentPageUrl.split('/');
  
  let sideBarUrl = document.querySelectorAll('.member-account-page .member-page-container .page-list-container ul li a')
  sideBarUrl.forEach((val) => {
    // console.log(typeof val.getAttribute('href'))
    if(val.getAttribute('href') != '' && val.getAttribute('href') != '#'){
      if(currentPageUrl == val.getAttribute('href')){
        val.classList.add('active');
      }
    }
  })
  
});

//For Members Coupon Page ==> Coupon code copy Function
$(document).ready(function(){
  
  $('.benefits-coupons-container .content-block .content-copy button').click(function(){
    let coupcode = $(this).siblings('h2').text();
    let btnText = $(this).text();
    
    copyToClipboard(coupcode, $(this), btnText)
  })

  $('.benefits-coupons-container .coupon-content .btn-with-content a').click(function(e){
    e.preventDefault();
   let selectedBtnText = $(this).text();
   let grandParent1 =  $(this).parents('.benefits-coupons-container .coupon-content');
   let grandParent2 = $(grandParent1).siblings();
   let findDiscount = $(grandParent2).find('.content-block .content-copy h2').text()
    
   copyToClipboard(findDiscount, $(this), selectedBtnText)
  })


  function copyToClipboard(couponCode, selectedElement, btnText){
    // Create a hidden input element
    var $tempInput = $("<input>");
    
    // Add the input element to the DOM
    $("body").append($tempInput);
    
    // Set the value of the input element to the text you want to copy
    $tempInput.val(couponCode);
    
    // Select the contents of the input element
    $tempInput.select();
    
    const successful = document.execCommand('copy');
    if(successful){
      $(selectedElement).text('Copied!');
    } else {
      $(selectedElement).text('Unable to copy!');        
    }
    // Remove the input element from the DOM
    $tempInput.remove();

    setTimeout(function(){
     $(selectedElement).text(btnText)
      // console.log("Hello")
    }, 3000)
  }
  
})

// When user change product size quick size warning box appear
$(document).ready(function(){
  $('.opt-dropdown li label').click(function(){
    $('.quick-size-warning').css("display","flex");
  })
})


//Free Product accordian  

  $('.free-product-accordion .accordian-title').click(function(){
       if($(this).hasClass('active')){
       $(this).removeClass('active');
       $('.template-product .free-product-accordion .free-products-list').hide(300);
    }else{
      $(this).addClass('active');
      $(`[tab-content="${ $(this).attr('tab-title') }"]`).show(300); 
         console.log($(this).attr('tab-title'))
    }
  })



$(document).ready(function(){
  
// Update Text Based on User Click on color  
let laceColor = document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]');
 laceColor.forEach((colorVariant) => {
   colorVariant.addEventListener('change', () => {
     document.querySelector('.comet-laces .swatches .option_selected_value').innerText = colorVariant.value;
   })
 })
  
})


// Image With Text Product Slider
$(document).ready(function(){
  
  function imageProductSlider(){
    $('.image-with-text-product-slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.1,
      slidesToScroll: 1,
      prevArrow: `<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
      nextArrow: `<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><polygon points="15.293 3.293 6.586 12 15.293 20.707 16.707 19.293 9.414 12 16.707 4.707 15.293 3.293"/></svg></button>`,
    }); 
  }
  
  imageProductSlider();
  document.addEventListener("ajaxloader:render", imageProductSlider);
}); 


$(document).ready(function(){
  function giftproductAddToCart() {
      let gift_product = document.querySelector('.gift-product-wrapper #gift-product');
       if( gift_product != null && gift_product != undefined){
        var gift_product_variant_id = gift_product.value;
       }
      let defaultCartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  
      function clickHandler() {
          if (gift_product.checked) {
              // console.log("Gift Product CheckBox Checked");
              if (gift_product_variant_id !== '') {
                 let giftProductData = {
                      "items": [{
                          "id": parseInt(gift_product_variant_id),
                          "quantity": 1
                      }],
                      sections: defaultCartDrawer.getSectionsToRender().map((section) => section.id)
                  };
                
                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(giftProductData)
                      })
                      .then(response => {
                          return response.json();
                      }).then(parsedState => {
                          defaultCartDrawer.renderContents(parsedState)
                          document.querySelector('.gift-product-wrapper').style.display="none"
                      })
                      .catch((error) => {
                          console.error('Gift Product Error:', error);
                      });
              }
          } else {
              console.log("CheckBox Unchecked");
          }
      }
    
     if( gift_product != null && gift_product != undefined){
        gift_product.addEventListener('click', clickHandler);
     }
  }
  
  document.addEventListener('cartChange', function () {
    giftproductAddToCart();
  });
    
  giftproductAddToCart();  

})

// Gift Product
$(document).ready(function(){
  var SelectedVariant = $(".template-product .product-form__input.gift-card input[type=radio]:checked").val();
  $(".template-product fieldset.product-form__input.gift-card .form__label span").append(SelectedVariant);
  
$(".template-product .product-form__input.gift-card input[type=radio]").click(function(){
  $(".template-product fieldset.product-form__input.gift-card .form__label span").empty();
  SelectedVariant = $(".template-product .product-form__input.gift-card input[type=radio]:checked").val();
  $(".template-product fieldset.product-form__input.gift-card .form__label span").append(SelectedVariant);
});

});

//Personalize Custom Field
$(document).ready(function(){  
  $('[value="No"]').click();
  $('.personalize-custom-field .personalize-accordian').click(function() {
      $('[value="Yes"]').click();
      $('.personalize-clear').show();
      $(this).addClass('active');
      $(`[tab-content="${ $(this).attr('tab-title') }"]`).show(300);   
  });

  $('.type-your-characters').on("change paste keyup", function() {
    var LeftValue = $('#type-your-characters-left-shoe').val();
    var RightValue = $('#type-your-characters-right-shoe').val();

    // Left & Right Shoe value not same comment script
    
    // if(LeftValue == RightValue){
    //   $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', true);
    //   $('.custom-field .append').empty().append('<p class="info-message">Left shoe & Right shoe values are same please change values</p>');
    // }else if(LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != ''){
    //   console.log('both empty1');
    //   $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', true);
    // }else {
    //   $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', false);
    //   $('.info-message').remove();
    // }

    if(LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != ''){
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', true);
    }else {
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', false);
      $('.info-message').remove();
    }
  });

  $('.personalize-clear').on( "click", function() {
    $(this).hide();
    $('[value="No"]').click();
    $('.personalize-clear').hide();
    $('.personalize-custom-field .personalize-accordian').removeClass('active');
    $('.template-product .personalize-custom-field .custom-field-block').hide(300);
    $('.custom-field-block input[type="radio"]:checked').prop('checked', false);
    $('.type-your-characters').val('');
  });

  $('.personalize-custom-field .custom-field-block .custom label[for="left-shoe"]').on( "click", function() {
    $(this).parent().parent('.left-right').siblings('.custom-field.left-shoe').show(300);
    $(this).parent().parent('.left-right').siblings('.custom-field.right-shoe').hide(300);

    var LeftValue = $('#type-your-characters-left-shoe').val();
    var RightValue = $('#type-your-characters-right-shoe').val();

    // Left & Right Shoe value not same comment script
    // if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != '' || LeftValue == RightValue) {

    if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != '') {
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', true);
    }else {
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', false);
    }
  });

  $('.personalize-custom-field .custom-field-block .custom label[for="right-shoe"]').on( "click", function() {
    $(this).parent().parent('.left-right').siblings('.custom-field.right-shoe').show(300);
    $(this).parent().parent('.left-right').siblings('.custom-field.left-shoe').hide(300);

    var LeftValue = $('#type-your-characters-left-shoe').val();
    var RightValue = $('#type-your-characters-right-shoe').val();

    // Left & Right Shoe value not same comment script
    // if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != '' || LeftValue == RightValue){

    if(LeftValue == '' && RightValue == '' || LeftValue != '' && RightValue == '' || LeftValue == '' && RightValue != ''){
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', true);
    }else {
      $('.template-product .product-form__buttons button[type="submit"]').prop('disabled', false);
    }
  });

  // $('.personalize-custom-field .custom-field-block .custom label+svg').on( "click", function() {
  //   $(this).parent().parent('.left-right').siblings('.custom-field').hide(300);
  //   $('.custom-field-block input[type="radio"]:checked').prop('checked', false);
  //   $('.type-your-characters').val('');
  // });

  $('.personalize-custom-field .custom-field-block .custom.left-side label+svg').on( "click", function() {
    $('.custom-field-block .custom.left-side input[type="radio"]:checked').prop('checked', false);
    $('.custom-field.left-shoe .type-your-characters').val('');
  });

  $('.personalize-custom-field .custom-field-block .custom.right-side label+svg').on( "click", function() {
    $('.custom-field-block .custom.right-side input[type="radio"]:checked').prop('checked', false);
    $('.custom-field.right-shoe .type-your-characters').val('');
  });
});


// Selected Variant Content Display
$(document).ready(function(){  
  $('.opt-dropdown li label').click(function(){
    var SelectedVariant = $(this).siblings().val();

    if ($(`.quick-size-warning p.variant-content[data-variant="${SelectedVariant}"]`).length) {
      $(`.quick-size-warning p.size-warning`).css('display','none');
      $(`.quick-size-warning p.variant-content`).removeClass("show")
      $(`.quick-size-warning p.variant-content[data-variant="${SelectedVariant}"]`).addClass("show");
    } else {
      $(`.quick-size-warning p.variant-content`).removeClass("show")
       $(`.quick-size-warning p.size-warning`).css('display','block');
    }

  })
});



document.addEventListener("DOMContentLoaded", (event) => {
function giftModules() {
    const g_cart_edit_option = document.querySelectorAll('.gift-product-wrapper');
    const cart_quantity_btn = document.querySelectorAll('.cart-item__quantity .quantity__input');
    const cart_url = `/cart.json`;
    const cart_change_url = `${window.Shopify.routes.root}cart/change.js`;
    const cart_update_url = `${window.Shopify.routes.root}cart/update.js`;
    const cart_post_url = `${window.Shopify.routes.root}cart/add.js`;
    
    // Get Cart Data
    const fetchCartData = async () => {
      try {
        const response = await fetch(cart_url);
        if (!response.ok) throw new Error("Can't get Cart data");
        const cart_data = await response.json();
        return cart_data;
      } catch (err) {
        console.error("Error Occur Dude", err);
        return null;
      }
    };
  
    
  // Remove Cart Note if goft product not in the cart
    let remove_cart_notes = async () => {
      try{
         let CartData = await fetchCartData();
          if(!CartData){
            throw Error("Something Wrong when get cart data inside remove_cart_notes function")
          }
        
          let is_cart_contain_gift = CartData['items'].some((cart_items) => cart_items.properties.hasOwnProperty('_gift_wrap'));
        
          if(!is_cart_contain_gift){
            let update_cart_notes = {
              note: '',
              attributes: {
                "note":''
              },
            }
  
            let update_note_in_cart =  await fetch(cart_update_url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(update_cart_notes)
            })
  
            if(!update_note_in_cart.ok){
              throw Error('Error Occur When Update Cart Not If gift product not in a cart');
            }
  
            let updated_cart_data = update_note_in_cart.json();
            return updated_cart_data;
          }
      }catch(error){
        console.log(error)
      }                   
    }
  
    // Update Line-item Property When gift product add to cart
    const updateCartItemProperty = async (productDetails) => {
      const d_CartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const error_msg_wrapper = document.querySelector(`.cart-item[data-item-key ="${productDetails.line_item_key}"] .cart-item__error-text`);
      const updates = {
        "id": productDetails.line_item_key,
        'quantity': productDetails.line_item_quantity,
        "properties": {
          "_gift_wrap": true
        },
        sections: d_CartDrawer.getSectionsToRender().map(section => section.id),
      };
      try {
        const response = await fetch(cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updates)
        });
  
        if (!response.ok) {
          const res = await response.json();
          // console.log(res, "res")
          error_msg_wrapper.innerHTML = res['message'];
          throw new Error(res.message);
        }
  
        const update_cart_data = await response.json();
        d_CartDrawer.renderContents(update_cart_data);
      } catch (err) {
        console.error(err);
        return null;
      }
    };
  
    
    // Add gift Product to cart when Gift checkbox is checked 
      const addProductToCart = async (productDetails, gift_product_variant_id, gift_product_variant_price) => {
      const error_msg_wrapper = document.querySelector(`.cart-item[data-item-key ="${productDetails.line_item_key}"] .cart-item__error-text`);
      const cart_notes = gift_product_variant_price;
      const cart_attribute_notes = `| Gift wrap - True | Item Value - ${gift_product_variant_price}`;
      const freeProductData = {
        "items": [{
          "id": parseInt(gift_product_variant_id),
          "quantity": 1,
          "properties": { "_gift_wrap": productDetails.variant_title, "_gift_hide_quantity": true }
        }],
        note: cart_notes,
        attributes: {
         note: cart_attribute_notes
        }
      };
  
      try {
        document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
        const response = await fetch(cart_post_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(freeProductData)
        });
  
        if (!response.ok) {
          const res = await response.json();
          if(res.status == 422){
             error_msg_wrapper.innerHTML = 'You can\'t add more Test Gift Wrap to the cart.';
          }else{
             error_msg_wrapper.innerHTML = res['message']
          }
          throw new Error(res.message);
        }
  
        const cart_response = await response.json();
        return await updateCartItemProperty(productDetails);
      } catch (err) {
        console.error(err);
        document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
        return null;
      }
    };
    // Add gift Product cart when cart checkbox is checked End
  
  // Function to find the gift pair in the cart
    const find_gift_pair = async (c_line_item_key) => {
      const result = await fetchCartData();
    
      if (!result || !result.items) {
        console.error("missing cart items array");
        return null;
      }
    
      const c_line_item = result.items.find(item => item.key === c_line_item_key);
    
      if (!c_line_item) {
        console.error("Current line item not found");
        return null;
      }
    
      const line_item_key = c_line_item.title;
      const g_wrap_paper = result.items.find(item => item.properties['_gift_wrap'] === line_item_key);
    
      if (!g_wrap_paper) {
        // console.error("No matching item found with _gift_wrap property");
        return null;
      }
    
      return {
        'gifted_product': c_line_item.key,
        'gift_paper': g_wrap_paper.key
      };
    };
  
    
  // Function to remove gift wrap pair
  const removeGiftWrapPair = async (current_line_item_key, cart_update_url, cart_change_url, current_line_item_quantity='1') => {
      try {
        const keys = await find_gift_pair(current_line_item_key);
        document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
        if (!keys){
           document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
           return;
        }
    
        // Selecting cart drawer || Notification Element
        const d_CartDrawer =  document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        
        if (!d_CartDrawer) {
          console.error("Cart drawer or notification element not found");
          document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
          return;
        }
    
        // Object to hold updates for removing gift paper
        let updates = {
          [keys.gift_paper]: 0,
        };
    
        // Function to remove gift paper from the cart
        const remove_gift_paper = async () => {
          try {
            const response = await fetch(cart_update_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            });
    
            if (!response.ok) {
              const res = await response.json();
              throw new Error(res.message);
            }
            
            return await response.json();
            
          } catch (err) {
            console.error(err);
             document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
            return null;
          }
        };
          
        // Object to hold updates for removing line item properties
        const props_updates = {
          id: keys.gifted_product,
          quantity: current_line_item_quantity,
          properties: {},
          sections: d_CartDrawer.getSectionsToRender().map(section => section.id)
        };
    
        // Function to remove line item properties from the cart
        const remove_line_item_props = async () => {
          try {
            const response = await fetch(cart_change_url, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(props_updates)
            });
    
            if (!response.ok) {
              const res = await response.json();
              // console.log(res, "res");
              throw new Error(res.message);
            }
    
            const cart_new_data = await response.json();
            console.log(cart_new_data, "cart_new_data")
            d_CartDrawer.renderContents(cart_new_data);
          } catch (err) {
            console.error(err);
            document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
            return null;
          }
        };
    
        // Sequential call to remove gift paper and then update line item properties
        await remove_gift_paper();
        await remove_line_item_props();
        await remove_cart_notes();
        
      } catch (err) {
        console.error(err);
      }
  };
    
  
    g_cart_edit_option.forEach((current_g_cart_edit_option) => {
      const inputField = current_g_cart_edit_option.querySelector('input[id^="gift-pro-option-list-"]');
  
      if (!inputField.dataset.listenerAdded) {
        inputField.addEventListener('change', async (event) => {
          const optionValue = event.target.checked;
          const productDetails = {
            productHandle: event.target.dataset.productHandle,
            variant_title: event.target.dataset.variantTitle,
            line_item_key: event.target.dataset.lineItemKey,
            line_item_quantity: event.target.dataset.lineItemQuantity,
            gift_variant_id: event.target.dataset.giftVariantId,
            gift_variant_price: event.target.dataset.giftVariantPrice
          };
          if (optionValue) {
            // const gift_product_variant_id = window.free_gift_product['variant_id'];
            const gift_product_variant_id = productDetails['gift_variant_id'];
            const gift_product_variant_price = productDetails['gift_variant_price'];
            await addProductToCart(productDetails, gift_product_variant_id, gift_product_variant_price);
            inputField.checked = false;
          }else{ 
              const current_line_item_key = productDetails.line_item_key;
              const current_line_item_quantity = productDetails['line_item_quantity'];
              removeGiftWrapPair(current_line_item_key, cart_update_url, cart_change_url, current_line_item_quantity);      
          }
        });
  
        inputField.dataset.listenerAdded = true;
      }
    });
    
  
    
  if(cart_quantity_btn){
    cart_quantity_btn.forEach((quantity_btn) => {
      quantity_btn.addEventListener('change', async (event) => {
  
        // Function to find the parent element with the data-item-key attribute
        const findParentWithDataItemKey = (element) => {
          while (element && !element.hasAttribute('data-item-key')) {
            element = element.parentElement;
          }
          return element;
        };
  
        const parentElement = findParentWithDataItemKey(event.target);
        const c_l_item_key = parentElement.dataset.itemKey;
  
        if(Number(event.target.value) == 0 && c_l_item_key) {
          try{
            let get_gift_paper = await find_gift_pair(c_l_item_key);
            if (!get_gift_paper) return;
  
            const defaultCartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            let updates = {
              'id': get_gift_paper.gift_paper,
              'quantity': 0,
              'sections': defaultCartDrawer.getSectionsToRender().map(section => section.id)
            }
  
            const remove_gift_paper = async () => {
              try {
                const response = await fetch(cart_change_url, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(updates)
                });
        
                if (!response.ok) {
                  const res = await response.json();
                  throw new Error(res.message);
                }
                const res = await response.json();
                document.querySelector('.cart-loader-wrapper').classList.remove('cart-loader-visible');
                defaultCartDrawer.renderContents(res);
                if(!res['items'].length){
                  defaultCartDrawer.classList.add('is-empty');
                }
             
                
              } catch (err) {
                console.error(err);
                return null;
              }
            };
            
            setTimeout(async () => {
             document.querySelector('.cart-loader-wrapper').classList.add('cart-loader-visible');
                await remove_gift_paper();  
                await remove_cart_notes();
            }, 1000)
            
          }catch(error){
            console.log(error)
          }
        }
      });
    });
  }
}

giftModules();

document.addEventListener('cartChange', () => {
  giftModules();
});

  
let color_swatch_func = () => {
  let swatch_show_more = document.querySelector('.moreless-button');
  let swatch_drawer = document.querySelector('.color-swatch-drawer');
  let swatch_drawer_inner = document.querySelector('.color-swatch-drawer-inner');
  let swatch_drawer_close = document.querySelector('.color-swatch-drawer .color-swatch-drawer-header button');
  let doc_body = document.querySelector('body');
  
    if(swatch_show_more && swatch_drawer){
        swatch_show_more.addEventListener('click', (e) => {
          e.preventDefault();
          swatch_drawer.classList.add('active');
          doc_body.classList.add('overflow-hidden', 'color-swatch-active')
        })
    
        swatch_drawer.addEventListener('click', () => {
          swatch_drawer.classList.remove('active');
           doc_body.classList.remove('overflow-hidden', 'color-swatch-active')
        });
        
        swatch_drawer_inner.addEventListener('click', (event) => {
            event.stopPropagation(); 
        });
  
       if(swatch_drawer_close){
          swatch_drawer_close.addEventListener('click', () => {
             swatch_drawer.classList.remove('active');
              doc_body.classList.remove('overflow-hidden', 'color-swatch-active')
          })
        }  
    }


     const labels = document.querySelectorAll('.swatches-image.lace-products');
        labels.forEach(label => {
          label.addEventListener('click', function() {
            // Find the corresponding radio input using the 'for' attribute of the label
            const inputId = this.getAttribute('for');
            const inputToCheck = document.querySelector(`#${inputId}`);
             labels.forEach(labeled => {
              labeled.classList.remove('i_checked');
             })
            
             label.classList.add('i_checked');
          });
      }); 
}
color_swatch_func(); 

  
 
// Function to apply the animation to the checked inputs
function applyAnimationToCheckedInputs() {
  // Apply animation to checked inputs
  document.querySelectorAll('.swatches-container.color-multi input[type="radio"]:checked').forEach(input => {
    const inputId = input.id;

    // Find all radio inputs with the same id
    document.querySelectorAll(`.swatches-container.color-multi input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
      // Find the corresponding label using the 'for' attribute
      const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
      if (label && label.querySelector('img')) {
        // Apply the rotation and transition
        const img = label.querySelector('img');
        img.style.transition = 'all .3s ease-in-out';
        img.style.transform = 'rotate(340deg)';
      }
    });
  });
}

// Event listener for changes to radio inputs
function setupChangeInputListener() {
  document.querySelectorAll('.swatches-container.color-multi input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      const inputId = this.id;

      // Set the checked state for both original and duplicate inputs
      document.querySelectorAll(`.swatches-container.color-multi input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
        duplicateInput.checked = true;

        // Find the corresponding label using the 'for' attribute
        const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
        if (label && label.querySelector('img')) {
          // Apply the rotation and transition
          label.querySelector('img').style.transition = 'all .3s ease-in-out';
          label.querySelector('img').style.transform = 'rotate(340deg)';
        }
      });
    });
  });
}
  
function applyAnimationToCheckedInputsLaces() {
  // Apply animation to checked inputs
  document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]:checked').forEach(input => {
    const inputId = input.id;

    // Find all radio inputs with the same id
    document.querySelectorAll(`.comet-laces .swatches-container input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
      // Find the corresponding label using the 'for' attribute
      const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
      if (label) {
        label.style.borderColor = '#ebef29!important';
      }
    });
  });
}

// Event listener for changes to radio inputs
function setupChangeInputListenerLaces() {
  document.querySelectorAll('.comet-laces .swatches-container input[type="radio"]').forEach(input => {
    input.addEventListener('change', function() {
      const inputId = this.id;

      // Set the checked state for both original and duplicate inputs
      document.querySelectorAll(`.comet-laces .swatches-container input[type="radio"][id="${inputId}"]`).forEach(duplicateInput => {
        duplicateInput.checked = true;

        // Find the corresponding label using the 'for' attribute
        const label = document.querySelector(`label[for="${duplicateInput.id}"]`);
        if (label) {
          label.style.borderColor = '#ebef29!important';
        }
      });
    });
  });
}

// Apply animation to checked inputs on page load

setupChangeInputListener();
applyAnimationToCheckedInputs();
setupChangeInputListenerLaces();
applyAnimationToCheckedInputsLaces();


// Handle AJAX content rendering
document.addEventListener("ajaxloader:render", function() {
  // Assuming this function is needed for AJAX content
  color_swatch_func();
  setupChangeInputListener();
  applyAnimationToCheckedInputs();
  setupChangeInputListenerLaces();
  applyAnimationToCheckedInputsLaces();
});

  
});


// Collection Page Grid list 
$(document).ready(function(){
  // Check localStorage for saved view preference
  if (localStorage.getItem('productView') === 'list') {
    $(".facets-container .facet-filters-containy").addClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").addClass("grid__custom_listy");
  } else {
    $(".facets-container .facet-filters-containy").removeClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").removeClass("grid__custom_listy");
  }

  // Handle list view button click
  $(".grid__products_style_btn_list svg").click(function(){
    $(".facets-container .facet-filters-containy").addClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").addClass("grid__custom_listy");
    // Save the preference to localStorage
    localStorage.setItem('productView', 'list');

    $(".grid-image-slider").slick("setPosition");
  });

  // Handle grid view button click
  $(".grid__products_style_btn_grid svg").click(function(){
    $(".facets-container .facet-filters-containy").removeClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").removeClass("grid__custom_listy");
    // Save the preference to localStorage
    localStorage.setItem('productView', 'grid');

    $(".grid-image-slider").slick("setPosition");
  });

  // show 2 items per row
  $(".grid__products_style_btn_grid_4").addClass("active");

  $(".grid__products_style_btn_grid_2 svg").click(function () {
    const $parent = $(this).closest(".grid__products_style_btn_grid_2");
    $parent.addClass("active").siblings().removeClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").addClass("grid_2");
    $(".product-grid-container .collection .pro__grid__list_containerz").removeClass("grid_4");

    $(".grid-image-slider").slick("setPosition");
  });

  // show 4 items per row
  $(".grid__products_style_btn_grid_4 svg").click(function () {
    const $parent = $(this).closest(".grid__products_style_btn_grid_4");
    $parent.addClass("active").siblings().removeClass("active");
    $(".product-grid-container .collection .pro__grid__list_containerz").addClass("grid_4");
    $(".product-grid-container .collection .pro__grid__list_containerz").removeClass("grid_2");

    $(".grid-image-slider").slick("setPosition");
  });

});

$(document).ready(function() {
  setTimeout(function() {
    $('.template-product #judgeme_product_reviews .jdgm-rev-widg__header .jdgm-row-stars .jdgm-histogram .jdgm-histogram__row[data-rating="null"]').addClass('jdgm-histogram__row--selected');
  }, 1000);
});



document.addEventListener("DOMContentLoaded", function() {
    function videoLazyLoad() {  
         let lazyVideos = [...document.querySelectorAll("video.video_lazy_load.lazy")]
          if(lazyVideos){
             if ("IntersectionObserver" in window) {
               let lazyVideoObserver = new IntersectionObserver(function(entries) {
                 entries.forEach(function(video) {
                   if (video.isIntersecting) {
                     for (let source in video.target.children) {
                       let videoSource = video.target.children[source];
                       if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                         videoSource.src = videoSource.dataset.src;
                       }
                     }
            
                     video.target.load();
                     video.target.classList.remove("lazy");
                     lazyVideoObserver.unobserve(video.target);
                   }
                 });
               });
            
               if(lazyVideos){
                 lazyVideos.forEach(function(lazyVideo) {
                   lazyVideoObserver.observe(lazyVideo);
                 });
               }
             }
          }
    }
  
  videoLazyLoad();
  document.addEventListener("ajaxloader:render", videoLazyLoad);

    let swatches_hide = () => {
    document.addEventListener('product:variant:changed', (event) => {
       let productId = document.querySelector('variant-radios')?.dataset.productId;

       if (productId === undefined) return;
       if(event.detail['variant']){
          let currentVariant = event.detail['variant']['options'];
          // console.log(event.detail['variant'], 'Variant Change Current Variant');
          findSoldoutOptions(window.product_object, currentVariant, productId);
       }
    });
    
   document.addEventListener('previous:product:variant', (event) => {
     let productId = event.detail['product_variant'] || document.querySelector('variant-radios')?.dataset.productId;
     if (productId === undefined) return;
       if(event.detail['currentVariant'] && event.detail['variantData'].length){
         let variantId = event.detail['currentVariant'];
         let variantList = event.detail['variantData'];
         let currentSelectedvariant = variantList.filter(variant => variant.id == variantId);
         let currentVariantOption = currentSelectedvariant[0]['options'];
         document.addEventListener("ajaxloader:load",function(){
            // console.log(variantList, 'variantList')
          findSoldoutOptions(window.product_object, currentVariantOption, productId);
         });
       }
   });  
  }

  function findSoldoutOptions(colorProducts = [], currentVariant, currentProductId){
    let swatchesLabels = document.querySelectorAll('.product-swatch-options .swatches-image');
    
    if (colorProducts.length && currentVariant.length && swatchesLabels.length) {
        swatchesLabels.forEach((swatcheLabel) => {
          swatcheLabel.classList.remove('hide-swatch');
        });

        let withOutCurrentProduct = colorProducts.filter(product => product.id != currentProductId);

          let matchedSwatches = [];
            withOutCurrentProduct.forEach((product) => {
                let hasMatchingSize = product.variants.some((variant) => {
                    return currentVariant.some(option => variant['options'].includes(option));
                });
    
                if (!hasMatchingSize) {
                    // If product doesn't include the selected size, add it to matchedSwatches
                    matchedSwatches.push(product);
                } else {
                    // Check if size exists but is unavailable
                    product.variants.forEach((variant) => {
                        if (
                            currentVariant.some(option => variant['options'].includes(option)) &&
                            variant['available'] === false &&
                            variant['inventory_management'] == "shopify" &&
                            variant['inventory_policy'] == "deny"
                        ) {
                            matchedSwatches.push(product);
                        }
                    });
                }
          });
         //Get available products
          let remainingSwatches = colorProducts.filter(product => 
            !matchedSwatches.includes(product)
          );
      
          hide_swatch(matchedSwatches, remainingSwatches);
    } else {
        console.log("No product data found");
    }
  }
  
  // findSoldoutOptions(window.product_object, currentvariant, swatches_labels);

  function hide_swatch(matchedVariant = [], availableProducts = []){
    // console.log(matchedVariant, "matchedVariantmatchedVariant")
    let swatchesToShow = document.querySelector('.product-swatch-options .swatches-container')?.dataset.colorToShow || 4;
      if(matchedVariant.length){
        
        // Hide swatches which is not available
          matchedVariant.forEach((swatcheLabel) => {
            // console.log(swatcheLabel.product_handle, "swatcheLabel.product_handle")
              const swatchElements = document.querySelectorAll(`.swatches-image[data-pro-handle="${swatcheLabel.product_handle}"]`);
              if (swatchElements.length > 0) {
                  swatchElements.forEach((element) => {
                    element.classList.add('hide-swatch');
                  });
              } else {
                  console.warn(`No swatch elements found for product_handle: ${swatcheLabel.product_handle}`);
              }
          });
          // console.log(matchedVariant, "matchedVariant")
       }
        // show swatches which is available but limited to show
        if(availableProducts.length){
            availableProducts.forEach((swatcheLabel, index) => {
                  const limitedSwatchElements = document.querySelectorAll(`.swatches-image.swatches-label[data-pro-handle="${swatcheLabel.product_handle}"]`);
                  if (limitedSwatchElements.length > 0 && index < Number(swatchesToShow)) {
                      limitedSwatchElements.forEach((element, currentIndex) => {
                        element.classList.remove('hide-swatch');
                      });
                  } else {
                      // console.warn(`No swatch elements found for product_handle: ${swatcheLabel.product_handle}`);
                      limitedSwatchElements.forEach((element) => {
                        element.classList.add('hide-swatch');
                      });
                  }
                
            });
           // console.log(availableProducts, "availableProducts") 
      } 
  }
  
  swatches_hide();
  document.addEventListener("ajaxloader:render", swatches_hide);


 // Update Inventory Stocks
if(window.inventory_details){
  for(let i in window.inventory_details){
    const inp = document.querySelector(`input[name="Size"][value="${i}"]`);
    if(inp){
      inp.nextElementSibling.querySelector('.inventory-count').innerText = window.inventory_details[i];
    }
  }
}
  
});



$(document).ready(function(){
  function initializeSlick() {
    $('.grid-image-slider').slick({
      speed: 300,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      // prevArrow: `<button class="slide-arrow prev-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
      // nextArrow: `<button class="slide-arrow next-arrow"><svg width="15" height="24" viewBox="0 0 15 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 22L3 12L13 2" stroke="#1F1F1F" stroke-width="3"/></svg></button>`,
    });
  }

  document.addEventListener("filter:product:grid:updated", function () {
    setTimeout(() => {
      initializeSlick();
    }, 500);
  });

  document.addEventListener("recommend:product:grid:image:slider", function () {
    // setTimeout(() => {
      initializeSlick();
    // }, 500);
  });

  // document.dispatchEvent(new CustomEvent("recommend:product:grid:image:slider"));

  initializeSlick();                         
});